var React = require('react');

function Bookmark (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons / bookmark"),React.createElement("g",{"id":"icons-/-bookmark","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("path",{"d":"M22,0 L22,24 L12,15 L2,24 L2,0 L22,0 Z M20,2 L4,2 L4,19.509 L12,12.3092752 L20,19.51 L20,2 Z","id":"bookmark","fill":"#1E1E1E"}))]);
}

Bookmark.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Bookmark;

Bookmark.default = Bookmark;
